import React, { useEffect, useState } from 'react';
import c from 'classnames';
import config from 'react-global-configuration';
import { useSelector } from 'react-redux';
import { addUtmQueryString } from '../../helpers/utm';

import {
  CoreLink,
} from '..';

const Button = (props) => {
  const {
    primary,
    secondary,
    textual,
    buttonIcon,
    children,
    className,
    fullWidth,
    buttonIconVertical,
    withIcon,
    icon,
    variant,
    type,
    disabled,
    inverted,
  } = props;

  const formsBaseUrls = config.get('BASE_URL_UTM_URLS');

  let {
    href,
  } = props;

  const utmCookiesSet = useSelector((state) => state.getIn(['uiInternal', 'utmCookiesSet'], false));
  const [utmLink, setUtmLink] = useState(href);

  const isInternal = ((url) => {
    if (/^internal:/.test(url)) {
      href = href.replace(/^internal:/, '');
      return true;
    }

    return false;
  })(href);

  const isEntity = ((url) => {
    if (/^entity:/.test(url)) {

      href = url.replace(/^entity:/, '');
      return true;
    }

    return false;
  })(href);

  const buttonClasses = c(`Button ${className}`, {
    'Button--primary': primary,
    'Button--secondary': secondary,
    'Button--textual': textual,
    'Button--inverted': inverted,
    'Button--disabled': disabled,
    'Button--full-width': fullWidth,
    'Button--icon icon-after': withIcon,
    'icon-arrow-right icon-before moving-arrow': buttonIcon || buttonIconVertical,
    'icon-arrow-down icon-before moving-arrow-vertical': buttonIconVertical,
    'icon-variant-1': (secondary && buttonIcon),
    'icon-variant-4': (primary && buttonIcon),
  }, icon ? `icon-${icon}` : '', variant || '');

  useEffect(() => {
    // If the url matches the UTM forms base url, add the UTM codes to it, if not set already.
    if (formsBaseUrls && href && utmCookiesSet) {
      const startsWithOne = formsBaseUrls.some(url => href.startsWith(url));

      if (startsWithOne) {
        setUtmLink(addUtmQueryString(href));
      } else {
        setUtmLink(href);
      }
    }
  }, [href, utmCookiesSet]);

  if (isInternal || isEntity) {
    return (
      <CoreLink {...props} className={buttonClasses} to={href}>
        {children}
      </CoreLink>
    );
  }

  if (type === 'submit') {
    return (
      <button type="submit" className={buttonClasses} {...props}>
        {children}
      </button>
    );
  }

  return (
    <a {...props} href={utmLink} className={buttonClasses}>
      {children}
    </a>
  );
};

export default Button;
